<template>
	<svg v-on="$listeners" class="svg-icon" :style="{ 'font-size': size + 'px', 'color': color }" aria-hidden="true">
		<use :xlink:href="'#' + iconId" />
	</svg>
</template>

<script setup>
import { ref, watch } from 'vue';
import to from 'await-to-js';

const props = defineProps({
	name: {
		type: String,
		required: true
	},
	size: {
		type: [String, Number],
		default: '14'
	},
	color: {
		type: String,
		default: '#4E5969'
	}
});
const iconId = ref('');

const getIcon = async iconName => {
	if (!iconName) return;

	const [err, svgSprite] = await to(
		new Promise((resolve, reject) => {
			import(`@/assets/icons/${iconName}.svg`)
				.then(svg => resolve(svg))
				.catch(reject);
		})
	);

	if (err) {
		console.log('😪 # getIcon # err:', err);
		return;
	}

	iconId.value = svgSprite?.default?.id;
};
watch(
	() => props.name,
	newVal => {
		if (newVal) {
			getIcon(newVal);
		}
	},
	{ immediate: true }
);
</script>

<style scoped>
.svg-icon {
	width: 1em;
	height: 1em;
	vertical-align: -0.15em;
	fill: currentColor;
	overflow: hidden;
}
</style>
